/*
 *  Document   : exa_template.js
 *  Author     : Exapoint
 *  Description: UI Framework custom functionality
 *
 */

// Import global dependencies

// Import required modules
import ExaHelpers from './exa_helpers';

// Template
export default class ExaTemplate {

    /*
     * Auto called when creating a new instance
     *
     */
    constructor() {
        this._exaInit();
    }

    /*
     * Init all vital functionality
     *
     */
    _exaInit() {
        ExaHelpers.run('client-side-logger');

        this._windowW = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        setTimeout(() => {
            ExaHelpers.run('extend-bootstrap-tabs');
            ExaHelpers.run('empty-links');
        }, 1)
    }

    /*
     * Run Helpers
     *
     */
    helpers(helpers, options = {}) {
        ExaHelpers.run(helpers, options);
    }
}
